import { render } from "./examens_tab.vue?vue&type=template&id=320e655f"
import script from "./examens_tab.vue?vue&type=script&lang=js"
export * from "./examens_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__